import { useState } from "react";
import { enterKeyHandler } from "../../../_utils/keyboard_events";
import { findOrderDetailById } from "../../../_services/orderDetail.service";
import { message } from "antd";

export default function BarcodeInput({ setEditOrder }){

    const [ focused, setFocused ] = useState(false);
    
    const setOrderDetail = (uuid) => {
        findOrderDetailById(uuid)
        .then(json => {
            if(!json.ok) throw new Error(json.error);
            if(!json.data) throw new Error("No se encontró referencia");
            const { order } = json.data;
            setEditOrder(json.data, order);
        })
        .catch(err => {
            message.error(err.message);
        });
        document.getElementById('barcode-input-rolled').value = '';
    }

    return(
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
            {
                focused ?  
                <div style={{ fontWeight: 'bold', fontSize: '1.3em', color: 'green' }}>LISTO PARA PISTOLEAR</div>
                : 
                <div style={{ fontWeight: 'bold', fontSize: '1.3em', color: 'red' }}>INGRESA EN EL CAMPO DE TEXTO</div>
            }
            <input
                id="barcode-input-rolled"
                autoFocus
                type="text"
                onFocus={() => {
                    setFocused(true);
                }}
                onBlur={() => {
                    setFocused(false);
                }}
                onKeyUp={(e) => {
                    enterKeyHandler(e, () => {
                        //setOrderDetail(e.target.value);
                        alert('Lectura de código de barras deshabilitado en enrollado hasta nueva orden. Comunicarse con Mark por favor');
                    })
                }}
            />
        </div>
    );

}